// 景观景点
<template>
  <el-card>
    <el-form inline ref="searchInfo" :model="info">
      <el-form-item prop="activityName">
        <el-input v-model="info.activityName" placeholder="请输入活动名称" clearable></el-input>
      </el-form-item>
      <el-form-item prop="projectId">
        <el-select v-model="info.projectId" placeholder="请选择公园名称" clearable filterable>
          <el-option v-for="(item, index) in parkList" :key="index" :label="item.projectName"
            :value="item.projectId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="state">
        <el-select v-model="info.state" placeholder="请选择活动状态" clearable>
          <el-option label="未开始" value="0"></el-option>
          <el-option label="进行中" value="1"></el-option>
          <el-option label="已结束" value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSearch">查询</el-button>
      </el-form-item>
    </el-form>
    <el-button class="mb20" @click='onAdd' type="primary" icon='el-icon-plus' v-if="$ButtonShow('TOA_ADD_01')">添加活动</el-button>
    <el-table class="global-table" v-loading="loading" :data="tableData">
      <el-table-column label="活动名称" show-overflow-tooltip prop="activityName"></el-table-column>
      <el-table-column label="所属公园" show-overflow-tooltip prop="projectName"></el-table-column>
      <el-table-column label="活动日期" show-overflow-tooltip min-width="150">
        <template v-slot="{ row }">
          <span v-if="row.startDate">{{ row.startDate }} - {{ row.endDate }}</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
            v-if="row.startTime">{{ row.startTime }} - {{ row.endTime }}</span>
        </template>
      </el-table-column>
      <el-table-column label="关注人数" show-overflow-tooltip prop="focusCount"></el-table-column>
      <el-table-column label="活动状态" show-overflow-tooltip prop="state">
        <template v-slot="{ row }">
          {{ row.state | stateFilter }}
        </template>
      </el-table-column>
      <el-table-column label="创建时间" show-overflow-tooltip prop="createTime"></el-table-column>
      <el-table-column label="操作" width="150px" fixed="right">
        <template v-slot="{ row }">
          <el-button type="text" @click="onDetail(row)">查看</el-button>
          <el-button type="text" v-if="row.state === '0' && $ButtonShow('TOA_EDT_01')" @click="onUpdate(row)">编辑</el-button>
          <el-button type="text" v-if="row.state === '0' && $ButtonShow('TOA_DEL_01')" @click="onDelete(row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <GlobalPagination @size-change="loadData" @current-change="loadData" :current-page.sync="page"
      :page-size.sync="size" :total="total">
    </GlobalPagination>
  </el-card>
</template>

<script>
import keepAlive from '@/mixins/keepAlive.js'
export default {
  name: 'Themeactivity',
  mixins: [keepAlive],
  data() {
    return {
      info: {
        activityName: '',
        projectId: this.$route.query.projectId || '',
        state: ''
      },
      loading: false,
      page: 1,
      size: 10,
      total: 0,
      tableData: [],
      parkList: []
    }
  },
  filters: {
    stateFilter(val) {
      switch (val) {
        case '0': return '未开始'
        case '1': return '进行中'
        case '2': return '已结束'
        default: return '--'
      }
    }
  },
  created() {
    this.loadData()
    this.getPark()
  },
  methods: {
    // 获取公园列表
    getPark() {
      this.$axios.get(this.$apis.project.selectYhProjectByPage, {
        projectType: '4',
        page: 1,
        size: 100,
        isCad: 0
      }).then(res => {
        this.parkList = res.list || []
      })
    },
    loadData() {
      this.loading = true
      this.$axios.get(this.$apis.tourist.selectTopicActivitiesByPage, {
        page: this.page,
        size: this.size,
        ...this.info,
        orderFocusCount: this.$route.query.orderFocusCount || ''
      }).then(res => {
        this.total = res.total || 0
        this.tableData = res.list || []
      }).finally(() => {
        this.loading = false
      })
    },
    onSearch() {
      this.page = 1
      this.loadData()
    },
    onAdd() {
      this.$router.push('/themeactivity/add')
    },
    onUpdate(item) {
      this.$router.push({
        name: 'ThemeactivityUpdate',
        params: { id: item.id },
        query: {
          projectId: item.projectId
        }
      })
    },
    onDetail(item) {
      this.$router.push({
        name: 'ThemeactivityDetail',
        params: { id: item.id },
        query: {
          projectId: item.projectId
        }
      })
    },
    onDelete(id) {
      this.$confirm('确认删除吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.tourist.deleteTopicActivities, {
          id: id
        }).then(() => {
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.loadData()
        })
      })
    }
  }
}
</script>

<style scoped lang="scss"></style>
